import { useRouter } from 'next/router';
import React from 'react';
import Image from '~/components/Image';

interface Props {}

const WhiteLabelSoftLanding: React.FC<Props> = () => {
  const router = useRouter();
  const logoUrl = router.query?.from_wlm_logo_url
    ? decodeURIComponent(router.query.from_wlm_logo_url as string)
    : null;

  return (
    <div className="mb-8 pt-4">
      <div className="flex flex-col justify-center space-x-2 rounded border px-2 py-3 text-lg shadow-sm md:mt-4 md:flex-row md:items-center">
        <div className="mb-2 text-center md:mb-0">
          <span className="font-semibold">Welcome to SidelineSwap</span> -
          Official Marketplace Partner of
        </div>

        <div>
          <Image
            className="mx-auto block h-10 w-auto"
            src={logoUrl}
            alt={String(router.query.from_wlm ?? '')}
          />
        </div>
      </div>
    </div>
  );
};

export default WhiteLabelSoftLanding;
